
import i18n from 'i18next';
import { useEffect } from 'react';
import { useData } from '@hooks/useData';
import { LANGUAGES, Language, isSupportedLanguage } from '@constants';
import { loadFromLocalStorage } from '@utils/storage';

export const useInitLanguage = () => {

    const { setLanguage } = useData();

    useEffect(() => {
        const stored = loadFromLocalStorage('language');
        let storedLanguage: Language | null = isSupportedLanguage(stored) ? stored : null;

        if (!storedLanguage) {
            const browserLanguageCode = navigator.language.slice(0, 2);
            const language = LANGUAGES.find(item => item.code === browserLanguageCode) || LANGUAGES[0];
            storedLanguage = language.code;
        }
        setLanguage(storedLanguage);
        i18n.changeLanguage(storedLanguage);
    }, []);
}